import { TFunction } from 'i18next';
import { GENRE } from 'services/types';

export const getGenreTranslationKey = (genreId: number): string | undefined => {
  const key = GENRE[genreId as GENRE];

  return typeof key === 'string' ? key : undefined;
};

export const getGenreLabel = (genreId: number, t: TFunction): string => {
  const key = getGenreTranslationKey(genreId);

  if (!key || genreId === GENRE.unknown) {
    return '';
  }

  return t(`enum.GENRE.${key}`);
};
